/**
 * Functional component for changing a location's notification thresholds.
 */

import { NotificationDisplayMap } from '@/constants';
import { useState } from 'react';
import { StatusRequestObject } from '../../account/types';

export default function ChangeNotificationStatusSection({
  status,
  threshold,
  cooldown,
  handleStatusUpdate,
}: {
  status: string;
  threshold: number;
  cooldown: number;
  handleStatusUpdate: (requestObject: StatusRequestObject) => void;
}): JSX.Element {

  const [newThreshold, setNewThreshold] = useState<number>(threshold);
  const [newCooldown, setNewCooldown] = useState<number>(cooldown);

  const handleLocalThresholdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const requestObj: StatusRequestObject = {
      statusType: status,
      threshold: parseInt(event.target.value),
      cooldown: newCooldown,
    };
    handleStatusUpdate(requestObj);
    setNewThreshold(parseInt(event.target.value));
  }

  const handleLocalCooldownChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const requestObj: StatusRequestObject = {
      statusType: status,
      threshold: newThreshold,
      cooldown: parseInt(event.target.value)
    };
    handleStatusUpdate(requestObj);
    setNewCooldown(parseInt(event.target.value));
  }

  return (
    <div>{NotificationDisplayMap[status as keyof typeof NotificationDisplayMap]}
      <div className="flex flex-wrap w-full gap-4 py-4">
        <div className="flex flex-col">
          Threshold
          <input
            type="number"
            value={newThreshold}
            className="form-input"
            onChange={handleLocalThresholdChange}
            data-cy="threshold-input"
          />
        </div>
        <div className="flex flex-col">
          Cooldown
          <input
            type="number"
            value={newCooldown}
            className="form-input"
            onChange={handleLocalCooldownChange}
            data-cy="cooldown-input"
          />
        </div>
      </div>
    </div>
  );
}